/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".textDataLabel[_ngcontent-%COMP%] {\n  font-size: 11px; }\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm5vZGVfbW9kdWxlcy9Ac3dpbWxhbmUvbmd4LWNoYXJ0cy9yZWxlYXNlL2Jhci1jaGFydC9iYXItbGFiZWwuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGVBQWUsRUFBRSIsImZpbGUiOiJub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1jaGFydHMvcmVsZWFzZS9iYXItY2hhcnQvYmFyLWxhYmVsLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIudGV4dERhdGFMYWJlbCB7XG4gIGZvbnQtc2l6ZTogMTFweDsgfVxuIl19 */"];
export { styles as styles };
